import { emit, events } from '@estee/elc-service-bus';
import { Product } from '../domain/entities/Product';

export interface IProductSelection {
    [key: string]: string;
}

export class ProductSelectedUseCase {
    private productUrl: string;
    private skuId: string;
    private positionIndex: number;
    private product: Product;

    constructor(productUrl: string, skuId: string, positionIndex: number, product: Product) {
        this.productUrl = productUrl;
        this.skuId = skuId;
        this.positionIndex = positionIndex;
        this.product = product;
    }

    public execute = async () => {
        emit(events.PRODUCT_CLICKED, { skuId: this.skuId, positionIndex: this.positionIndex, product: this.product });
        window.location.assign(this.productUrl);
    };
}
